import {
  updateSelectElm,
  timestampToDate,
  formatDateForSelect,
  updateHTMLElementWithDates,
} from "./demo-dates-lib";

// This script works alongside content-resource.php to display the Webinar dates
// according to the browser's timezone

const webinarDates = document.querySelectorAll(".js-webinar-date");
const dates = convertNodeListToDates(webinarDates);
if (dates) {
  updateSelectUI(dates);
  updateHTMLWebinarDatesUI(dates);
}

/**
 * @param {NodeListOf<Element>} webinarDates //Must have data attr of webinar-date formatted as UNIX Timestamp
 * @returns {{ text: string; value: string; }[]} dateArr
 */
export function convertNodeListToDates(webinarDates) {
  const dateArr = [];
  if (webinarDates) {
    for (let i = 0; i < webinarDates.length; i++) {
      const webinarDate = webinarDates[i]?.getAttribute("data-webinar-date");
      if (webinarDate) {
        // Check to make sure date is in the future before adding it.
        const now = Math.floor(new Date().getTime() / 1000); // get timestamp in seconds.
        if (now < parseInt(webinarDate)) {
          const dateObject = timestampToDate(webinarDate);
          dateArr.push(formatDateForSelect(dateObject));
        }
      }
    }
  }
  return dateArr;
}

/**
 * @param {{text: string, value: string}[]} dates
 */
function updateHTMLWebinarDatesUI(dates) {
  const webinarDates = document.querySelectorAll(".webinar-dates-holder");

  if (
    location.pathname != "/resources/pdu-training/pagerduty-101/" &&
    location.pathname != "/resources/pdu-training/event-intelligence-101/"
  ) {
    for (let x = 0; x < webinarDates.length; x++) {
      updateHTMLElementWithDates(webinarDates[x], dates);
    }
  }
}

/**
 * @param {{text: string, value: string}[]} dates
 */
function updateSelectUI(dates) {
  const webinarInput = document.getElementById("recurringWebinarDate");
  if (webinarInput instanceof HTMLSelectElement) {
    updateSelectElm(webinarInput, dates, "Select One");
  }
}
